module.exports = __webpack_public_path__ + "img/logo.607be0d0.png";